import React from 'react';
import { CircularProgress as MuiCircularProgress } from '@mui/material';

import { IPreloader } from './preloader.models';
import { useStyles } from './preloader.styles';
import { cx } from '../../../utils';

export const Preloader = ({ isPageLevel, size, isInner }: IPreloader): JSX.Element => {
  const classes = useStyles();

  return (
    <div
      className={cx(
        classes.root,
        {
          [classes.rootPageLevel]: isPageLevel,
          [classes.inner]: isInner,
        },
      )}
    >
      <MuiCircularProgress
        data-testid="preloader"
        classes={{
          root: !isInner ? classes.circularProgressRootInner : classes.circularProgressRoot,
          colorPrimary: classes.circularProgressColorPrimary,
        }}
        size={size}
      />
    </div>
  );
};
